module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_16.032a1a8c.pdf";